<div class="aca-admin aca-frs">
  <aca-page-header
    icon="table_view"
    [title]="form() ? ('DMS.FORMS.REPORT_TITLE' | translate: { title: form()!.title }) : ('DMS.FORMS.REPORT' | translate)"
    [subtitle]="form() ? ('DMS.FORMS.REPORT_COUNT' | translate: { count: all().length }) : ''"
  >
    <a class="aca-frs__outline" routerLink="/forms"><mat-icon>arrow_back</mat-icon>{{ 'DMS.FORMS.BACK' | translate }}</a>
    <button type="button" class="aca-frs__outline" (click)="reload()" [disabled]="loading()">
      <mat-icon>refresh</mat-icon>{{ 'DMS.FORMS.REFRESH' | translate }}
    </button>
    <button type="button" class="aca-frs__outline" (click)="exportCsv()" [disabled]="!filtered().length">
      <mat-icon>description</mat-icon>{{ 'DMS.FORMS.EXPORT_CSV' | translate }}
    </button>
    <button type="button" class="aca-frs__primary" (click)="exportExcel()" [disabled]="!filtered().length">
      <mat-icon>grid_on</mat-icon>{{ 'DMS.FORMS.EXPORT_EXCEL' | translate }}
    </button>
  </aca-page-header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />
  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.FORMS.REPORT_LOAD_FAILED' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.FORMS.REFRESH' | translate"
    (action)="reload()"
  />

  <ng-container *ngIf="!loading() && !failed() && form()">
    <aca-page-state
      *ngIf="!all().length"
      state="empty"
      icon="inbox"
      [title]="'DMS.FORMS.REPORT_EMPTY' | translate"
      [message]="'DMS.FORMS.REPORT_EMPTY_HINT' | translate"
    />

    <ng-container *ngIf="all().length">
      <div class="aca-frs__toolbar">
        <label class="aca-frs__search">
          <mat-icon>search</mat-icon>
          <input
            type="search"
            [attr.aria-label]="'DMS.FORMS.REPORT_SEARCH' | translate"
            [placeholder]="'DMS.FORMS.REPORT_SEARCH' | translate"
            [ngModel]="query()"
            (ngModelChange)="query.set($event)"
          />
        </label>
        <div class="aca-frs__date">
          <label class="aca-frs__datelabel" for="frs-from">{{ 'DMS.FORMS.REPORT_FROM' | translate }}</label>
          <aca-date-input inputId="frs-from" name="from" [ngModel]="from()" (ngModelChange)="from.set($event || '')" />
        </div>
        <div class="aca-frs__date">
          <label class="aca-frs__datelabel" for="frs-to">{{ 'DMS.FORMS.REPORT_TO' | translate }}</label>
          <aca-date-input inputId="frs-to" name="to" [ngModel]="to()" (ngModelChange)="to.set($event || '')" />
        </div>
        <button type="button" class="aca-frs__link" *ngIf="narrowed()" (click)="clearFilters()">
          <mat-icon>filter_alt_off</mat-icon>{{ 'DMS.FORMS.REPORT_CLEAR' | translate }}
        </button>
        <span class="aca-frs__count" role="status">{{
          'DMS.FORMS.REPORT_MATCHING' | translate: { count: filtered().length, total: all().length }
        }}</span>
      </div>
      <p class="aca-frs__note"><mat-icon>shield</mat-icon>{{ 'DMS.FORMS.REPORT_PRIVACY' | translate }}</p>

      <aca-page-state *ngIf="!filtered().length" state="empty" icon="search_off" [title]="'DMS.FORMS.REPORT_NONE_MATCH' | translate" />

      <div class="aca-frs__tablewrap" *ngIf="filtered().length">
        <table class="aca-frs__table">
          <thead>
            <tr>
              <th class="aca-frs__sticky">{{ 'DMS.FORMS.COL_REFERENCE' | translate }}</th>
              <th>{{ 'DMS.FORMS.COL_SUBMITTED' | translate }}</th>
              <th>{{ 'DMS.FORMS.COL_SENDER' | translate }}</th>
              <th *ngFor="let column of columns()" [class.aca-frs__old]="!column.field">
                {{ column.label }}
                <mat-icon *ngIf="!column.field" class="aca-frs__oldicon" [matTooltip]="'DMS.FORMS.REPORT_OLD_FIELD' | translate">history</mat-icon>
              </th>
              <th>{{ 'DMS.FORMS.COL_FLOW' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let submission of visible()">
              <td class="aca-frs__sticky">
                <a class="aca-frs__ref" *ngIf="submission.nodeId; else plainRef" [routerLink]="['/document', submission.nodeId]">{{
                  submission.reference
                }}</a>
                <ng-template #plainRef
                  ><span class="aca-frs__ref">{{ submission.reference }}</span></ng-template
                >
                <span class="aca-frs__sub">
                  {{ 'DMS.FORMS.VERSION' | translate: { version: submission.formVersion } }}
                  <mat-icon *ngIf="submission.signed" class="aca-frs__signed" [matTooltip]="'DMS.FORMS.COL_SIGNED' | translate">verified</mat-icon>
                </span>
              </td>
              <td class="aca-frs__nowrap">{{ when(submission) }}</td>
              <td class="aca-frs__nowrap">
                {{ submission.byName }}<span class="aca-frs__sub">{{ submission.by }}</span>
              </td>
              <td
                *ngFor="let column of columns()"
                [class.aca-frs__num]="column.field?.type === 'money' || column.field?.type === 'number' || column.field?.type === 'calc'"
              >
                <span class="aca-frs__cell" [title]="cell(submission, column)">{{ cell(submission, column) }}</span>
              </td>
              <td>
                <a class="aca-frs__flow" *ngIf="submission.processId" [routerLink]="['/workflows/instances', submission.processId]">
                  <mat-icon>account_tree</mat-icon>{{ 'DMS.FORMS.REPORT_FOLLOW' | translate }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="aca-frs__more" *ngIf="filtered().length > visible().length" (click)="more()">
        {{ 'DMS.FORMS.REPORT_MORE' | translate: { shown: visible().length, count: filtered().length } }}
      </button>
    </ng-container>
  </ng-container>
</div>
